



































import {
  Vue,
  Component
} from "@/shared/vuepack";
import moment from "moment-timezone";
import ContributionsGraphWidget from "@/shared/components/contribution/ContributionsGraphWidget.vue";
import RecurringPayrollContribution from "@/shared/components/contributionsV3/RecurringPayrollContribution.vue";
import OneTimePayrollContribution from "@/shared/components/contributionsV3/OneTimePayrollContribution.vue";
import { useHsaTotalStore } from "@/shared/store/hsaTotal";

@Component({
  components: {
    ContributionsGraphWidget,
    RecurringPayrollContribution,
    OneTimePayrollContribution
  }
})

export default class ManagePayrollContributions extends Vue {
  hsaTotalStore = useHsaTotalStore();
  forecastYear = moment().year();
  isOneTimeContribution = false;
  pendingContributionAmount = 0;

  mounted () {
    this.hsaTotalStore.getUserPayrollSummary();
  }

  get allowedForecastYears (): number[] {
    return [moment().year()];
  }

  setPendingContributionAmount (amount: number) {
    this.pendingContributionAmount = amount;
  }
}
